// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-attendance{
  padding: 0 10px;
  display: flex;
  justify-content: center;
  font-size: 26px;
  color: #434C63;
  border: 1px solid #434C63;
  text-align: center;
}

.attendance-title{
  margin-bottom: 20px;
  font-size: 24px;
  color: #434C63;
}

.mobile-attendance{
  display: none;
}

@media screen  and (max-width: 520px) {
  .no-attendance{
    justify-content: flex-start;
  }

  .mobile-attendance{
    display: flex;
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ClassAttendance/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,sBAAsB;EACxB;AACF","sourcesContent":[".no-attendance{\n  padding: 0 10px;\n  display: flex;\n  justify-content: center;\n  font-size: 26px;\n  color: #434C63;\n  border: 1px solid #434C63;\n  text-align: center;\n}\n\n.attendance-title{\n  margin-bottom: 20px;\n  font-size: 24px;\n  color: #434C63;\n}\n\n.mobile-attendance{\n  display: none;\n}\n\n@media screen  and (max-width: 520px) {\n  .no-attendance{\n    justify-content: flex-start;\n  }\n\n  .mobile-attendance{\n    display: flex;\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
